// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vnW6","footer":"styles_footer__3gag8","passCodeTooltip":"styles_passCodeTooltip__JyTDB"};